import React from 'react';

import AppMenu from '../AppMenu';

interface IPageLayoutProps {
    showMenu: boolean
    children: any
}

function PageLayout({ showMenu, children }: IPageLayoutProps) {
    return (
        <div id='page-layout'>
            {
                showMenu &&
                < div id='menu-containter'>
                    <AppMenu />
                </div>
            }
            <div id='content-containter'>
                {children}
            </div>
        </div >
    );
}

export default PageLayout;
